// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"oT-z","inlineTitle":"pT-z","sponsoredAdsWrapper":"qT-z","marketplaceRecosWrapper":"rT-z"};